module.exports = __webpack_public_path__ + "static/clickygame-9dbf50f2324ba1623b92683fb7f693c4.png";